import Model from 'mixins/model';

export default class CoverModel extends Model {
    constructor() {
        super();
    }
    static fromJSON({
        image,
        orderWeight,
        url,
        journal,
    } = data) {
        const coverModel = new CoverModel();

        coverModel.set('image', image);
        coverModel.set('orderWeight', orderWeight);
        coverModel.set('journal', journal);
        coverModel.set('url', url);

        return coverModel;
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/models/CoverModel.js